module.exports = __webpack_public_path__ + "img/p-one-step-20.4af18ef5.png";